import React, { useState, useCallback } from 'react'

import { useDropzone } from "react-dropzone";
// Icons --------------------------
import { Plug, RefreshCw, Calculator, CircleCheck, Building, UsersGear, Flask, LinkSlash, Link, FileInvoice, CloudUploadAlt, Check, SettingCog, Play, ChartLine, Coins, Clock, BuildingColumns, Upload, Download, ListUl } from '../../../../../../../components/icons/Icons'
import { Col, Form, Row } from 'react-bootstrap'
import { Switch } from '@mui/material';

const Integrations = () => {
  const MAX_SIZE = 10 * 1024 * 1024; // 10 MB
  const [files, setFiles] = useState([]);
  const [usedSize, setUsedSize] = useState(0);

  const onDrop = useCallback((acceptedFiles) => {
    const newSize = acceptedFiles.reduce((acc, file) => acc + file.size, 0);

    // Check total size
    if (usedSize + newSize > MAX_SIZE) {
      alert("Total size 10MB se zyada nahi ho sakti!");
      return;
    }

    setFiles((prev) => [
      ...prev,
      ...acceptedFiles.map((file) =>
        Object.assign(file, { preview: URL.createObjectURL(file) })
      ),
    ]);
    setUsedSize((prev) => prev + newSize);
  }, [usedSize]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    // accept: {
    //   "image/*": [], // sirf images allow
    // },
    accept: {
      "application/*": [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".csv"],
    },
    multiple: true,
    maxSize: 10 * 1024 * 1024, // 5MB
  });

  // 🔹 Remove function
  const removeFile = (name, size) => {
    setFiles((prev) => prev.filter((file) => file.name !== name));
    setUsedSize((prev) => prev - size);
  };

  return (
    <div>
      <div className='d-flex align-items-center justify-content-between'>
        <div className='mt-4'>
          <h3 className='color-white font-weight-200'>Integrations</h3>
          <h5 className='color-gray font-weight-200 mt-1'>Connect SeekNow TDS module with external systems and services</h5>
        </div>

        <div className='mt-4 d-flex align-items-center gap-2'>
          <Plug class_name={"green-text"} />
          <span className='color-gray'> 3 of 6 integrations active</span>
          <button className='universal-btn border-radius-8px d-flex align-items-center gap-2 px-4 py-3'> <RefreshCw /> Sync All</button>
        </div>
      </div>

      {/* Section 0 ----------------------- */}
      <section className="setting-border height-auto mt-4 mb-4">
        <div className='setting-card-header'>
          <h3 className='color-white font-weight-200'> <Calculator class_name="section-icon text-purple" /> Payroll Software </h3>
          <span className='color-gray font-14'> 2 of 3 connected</span>
        </div>

        <div className='p-4 mb-8'>
          <Row>
            <Col sm="4">
              <div className='p-4 integration-card active'>
                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>
                  <div className='d-flex align-items-center gap-2'>
                    <span className='orange-icon-container'>
                      <Calculator class_name="section-icon" />
                    </span>
                    <div>
                      <h3 className='color-white font-weight-200'>Tally ERP</h3>
                      <h5 className='color-gray font-weight-200'>Payroll & Accounting</h5>
                    </div>
                  </div>
                  <span className='badge-green'><CircleCheck /> Connected</span>
                </div>

                <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
                  <span className="color-gray font-weight-200 font-14">Last Sync:</span>
                  <span className='green-text font-weight-200 font-14'>2 hours ago</span>
                </div>
                <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
                  <span className="color-gray font-weight-200 font-14">Records Synced:</span>
                  <span className='color-white font-weight-200 font-14'>1,247</span>
                </div>
                <div className='d-flex align-items-center justify-content-between gap-2 mb-5'>
                  <span className="color-gray font-weight-200 font-14">Last Sync:</span>
                  <span className='green-text font-weight-200 font-14'>2 hours ago</span>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-2 mb-3'>
                  <button className='test-btn'> <Flask class_name={"text-purple"} /> Test</button>
                  <button className='diconnect-btn '> <LinkSlash />  Disconnect</button>
                </div>
              </div>
            </Col>
            {/* ----------------------- */}
            <Col sm="4">
              <div className='p-4 integration-card active'>
                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>
                  <div className='d-flex align-items-center gap-2'>
                    <span className='blue-icon-container'>
                      <Building class_name="section-icon blue-text " />
                    </span>
                    <div>
                      <h3 className='color-white font-weight-200'>Tally ERP</h3>
                      <h5 className='color-gray font-weight-200'>Payroll & Accounting</h5>
                    </div>
                  </div>
                  <span className='badge-green'><CircleCheck /> Connected</span>
                </div>

                <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
                  <span className="color-gray font-weight-200 font-14">Last Sync:</span>
                  <span className='green-text font-weight-200 font-14'>2 hours ago</span>
                </div>
                <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
                  <span className="color-gray font-weight-200 font-14">Records Synced:</span>
                  <span className='color-white font-weight-200 font-14'>1,247</span>
                </div>
                <div className='d-flex align-items-center justify-content-between gap-2 mb-5'>
                  <span className="color-gray font-weight-200 font-14">Last Sync:</span>
                  <span className='green-text font-weight-200 font-14'>2 hours ago</span>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-2 mb-3'>
                  <button className='test-btn'> <Flask class_name={"text-purple"} /> Test</button>
                  <button className='diconnect-btn '> <LinkSlash /> Disconnect</button>
                </div>
              </div>
            </Col>
            {/* ----------------------- */}
            <Col sm="4">
              <div className='p-4 integration-card'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <div className='d-flex align-items-center gap-2'>
                    <span className='red-icon-container'>
                      <UsersGear class_name="section-icon" />
                    </span>
                    <div>
                      <h3 className='color-white font-weight-200'>Tally ERP</h3>
                      <h5 className='color-gray font-weight-200'>Payroll & Accounting</h5>
                    </div>
                  </div>
                  <span className='badge-red'><CircleCheck /> Not Connected</span>
                </div>

                <div className='setting-border height-auto mt-4 p-4 mb-3'>
                  <Form.Group className='mb-4'>
                    <Form.Label className='color-white'>API Key</Form.Label>
                    <Form.Control className='universal-input' placeholder='Enter Zoho Payroll API key' />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label className='color-white'>Organization ID</Form.Label>
                    <Form.Control className='universal-input' placeholder='Enter Organization ID' />
                  </Form.Group>

                </div>
                <button className='universal-btn border-radius-8px px-4 d-flex align-items-center justify-content-center gap-2' style={{ width: "100%", height: "40px" }}> <Link class_name={"font-20"} /> Connect to Zoho Payroll</button>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* Section 1 ----------------------- */}
      <section className="setting-border height-auto mt-4 mb-4">
        <div className='setting-card-header'>
          <h3 className='color-white font-weight-200'> <FileInvoice class_name="section-icon text-purple" /> Form 16 Generator </h3>
          <span className='color-gray font-14 font-weight-200 '>Template configured </span>
        </div>

        <div className='p-4 mb-8'>
          <Row>
            <Col sm="12">
              <div className='p-4 height-auto integration-card active' style={{ height: "auto" }}>
                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>
                  <div className='d-flex align-items-center gap-2'>
                    <span className='purple-icon-container'>
                      <FileInvoice class_name="section-icon" />
                    </span>
                    <div>
                      <h3 className='color-white font-weight-200'>Automated Form 16 Generation</h3>
                      <h5 className='color-gray font-weight-200'>Generate Form 16 from TDS calculations</h5>
                    </div>
                  </div>
                  <span className='badge-green'><CircleCheck /> Active</span>
                </div>

                <Row>
                  <Col sm="6">
                    <h4 className='color-gray font-weight-200 font-14 mb-4'>Template Upload</h4>

                    <div
                      {...getRootProps()}
                      // style={{
                      //   background: isDragActive ? "#f0f8ff" : "#00000010",
                      // }}
                      className="dropzone mt-4 mb-4"
                    >
                      <input {...getInputProps()} />
                      {isDragActive ? (
                        <p>Drop the files here...</p>
                      ) : (
                        <div className="dropzone-inner-layout">
                          <span> <CloudUploadAlt /> </span>
                          <h3 className="mt-4 color-white font-weight-200">Drag & drop some files here</h3>
                          <h5 className="mb-3 color-gray font-weight-200 font-14">or click to browse</h5>
                          <h4 className="color-gray font-weight-200">Supports: PDF, DOC, EXCEL . Max size: 10MB</h4>
                          <h3 className='text-purple font-weight-200 font-14 mt-2'>Upload New Template</h3>
                        </div>
                      )}
                    </div>

                    <h4 className='color-gray font-weight-200 font-14 mb-4'>Field Mapping</h4>
                    <div className='setting-border height-auto p-4'>
                      <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                        <span className='color-gray font-14 font-weight-200'>Employee Name</span>
                        <span className='green-text'><Check class_name={"green-text"} /> Mapped </span>
                      </div>
                      {/* ---------------------- */}
                      <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                        <span className='color-gray font-14 font-weight-200'>PAN Number</span>
                        <span className='green-text'><Check class_name={"green-text"} /> Mapped </span>
                      </div>
                      {/* ---------------------- */}
                      <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                        <span className='color-gray font-14 font-weight-200'>TDS Amount</span>
                        <span className='green-text'><Check class_name={"green-text"} /> Mapped </span>
                      </div>
                      {/* ---------------------- */}
                      <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                        <span className='color-gray font-14 font-weight-200'>Financial Year</span>
                        <span className='green-text'><Check class_name={"green-text"} /> Mapped </span>
                      </div>
                      {/* ---------------------- */}
                    </div>

                    {/* ------------- */}
                    <div className='d-flex align-items-center gap-2 mb-2 mt-4'>
                      <button className='test-btn'> <Play class_name={"text-purple"} /> Test Generation</button>
                      <button className='universal-btn border-radius-8px d-flex align-items-center justify-content-center gap-2 px-3' style={{ height: "40px" }}> <SettingCog /> Configure</button>
                    </div>
                  </Col>
                  {/* ---------------------- */}
                  <Col sm="6">
                    <h4 className='color-gray font-weight-200 font-14 mb-4'>Generation Settings</h4>
                    <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                      <span className='color-white font-14 font-weight-200'>Auto-generate after approval</span>
                      <Switch checked />
                    </div>
                    {/* ---------------------- */}
                    <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                      <span className='color-white font-14 font-weight-200'>Auto-generate after approval</span>
                      <Switch checked />
                    </div>
                    {/* ---------------------- */}
                    <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                      <span className='color-white font-14 font-weight-200'>Auto-generate after approval</span>
                      <Switch checked />
                    </div>
                    {/* ---------------------- */}
                    <h3 className='color-gray font-14 font-weight-200 mb-4'>Generation Stats</h3>
                    <div className='setting-border height-auto p-4'>
                      <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                        <span className='color-gray font-14 font-weight-200'>Forms generated this FY:</span>
                        <span className='color-white'>2847 </span>
                      </div>
                      {/* ---------------------- */}
                      <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                        <span className='color-gray font-14 font-weight-200'>Last generation:</span>
                        <span className='green-text'> Today, 10:30 AM </span>
                      </div>
                      {/* ---------------------- */}
                      <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                        <span className='color-gray font-14 font-weight-200'>Success rate:</span>
                        <span className='green-text'> 99.8% </span>
                      </div>
                      {/* ---------------------- */}
                    </div>

                  </Col>
                </Row>
              </div>
            </Col>

          </Row>


        </div>

      </section>

      {/* Section 2 ----------------------- */}
      <section className="setting-border height-auto mt-4 mb-4">
        <div className='setting-card-header'>
          <h3 className='color-white font-weight-200'> <ChartLine class_name="section-icon text-purple" /> Finance Systems </h3>
          <span className='color-gray font-14 font-weight-200 '> 1 of 2 connected </span>
        </div>

        <div className='p-4 mb-8'>
          <Row>
            <Col sm="6">
              <div className='p-4 integration-card active'>
                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>
                  <div className='d-flex align-items-center gap-2'>
                    <span className='green-icon-container'>
                      <ChartLine class_name="section-icon" />
                    </span>
                    <div>
                      <h3 className='color-white font-weight-200'>Enterprise ERP</h3>
                      <h5 className='color-gray font-weight-200'>Salary structures & GL codes</h5>
                    </div>
                  </div>
                  <span className='badge-green'><CircleCheck /> Completed</span>
                </div>


                <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                  <span className='color-gray font-14 font-weight-200'>Salary structures:</span>
                  <span className='color-white font-weight-200'> 847 synced </span>
                </div>
                {/* ---------------------- */}
                <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                  <span className='color-gray font-14 font-weight-200'>GL codes mapped:</span>
                  <span className='color-white font-weight-200'> 156 </span>
                </div>
                {/* ---------------------- */}
                <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                  <span className='color-gray font-14 font-weight-200'>Last sync:</span>
                  <span className='green-text'>1 hour ago </span>
                </div>


                {/* ------------- */}
                <div className='d-flex align-items-center justify-content-center gap-2 mb-2 mt-4'>
                  <button style={{ width: "100%" }} className='test-btn'> <Flask class_name={"text-purple"} /> Test</button>
                  <button style={{ width: "100%", height: "40px" }} className='universal-btn border-radius-8px d-flex align-items-center justify-content-center gap-2 px-3'> <RefreshCw /> Sync</button>
                </div>

              </div>
            </Col>
            {/* --------------- */}
            <Col sm="6">
              <div className='p-4 integration-card'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <div className='d-flex align-items-center gap-2'>
                    <span className='green-icon-container'>
                      <Coins class_name="section-icon" />
                    </span>
                    <div>
                      <h3 className='color-white font-weight-200'>Budget Management</h3>
                      <h5 className='color-gray font-weight-200'>TDS budget tracking</h5>
                    </div>
                  </div>
                  <span className='badge-yellow'><Clock /> Pending Setup</span>
                </div>

                <div className='setting-border height-auto mt-4 p-4 mb-3'>
                  <Form.Group className='mb-4'>
                    <Form.Label className='color-white'>API Key</Form.Label>
                    <Form.Control className='universal-input' placeholder='Enter Zoho Payroll API key' />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label className='color-white'>Organization ID</Form.Label>
                    <Form.Control className='universal-input' placeholder='Enter Organization ID' />
                  </Form.Group>

                </div>
                <button className='universal-btn border-radius-8px px-4 d-flex align-items-center justify-content-center gap-2' style={{ width: "100%", height: "40px" }}> <Link class_name={"font-20"} /> Connect to Zoho Payroll</button>
              </div>
            </Col>

          </Row>


        </div>

      </section>

      {/* Section 3 ----------------------- */}
      <section className="setting-border height-auto mt-4 mb-4">
        <div className='setting-card-header'>
          <h3 className='color-white font-weight-200'> <BuildingColumns class_name="section-icon text-purple" /> Government Portals </h3>
          <span className='color-gray font-14 font-weight-200 '>TRACES integration </span>
        </div>

        <div className='p-4 mb-8'>
          <Row>
            <Col sm="12">
              <div className='p-4 height-auto setting-border active' style={{ height: "auto" }}>
                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>
                  <div className='d-flex align-items-center gap-2'>
                    <span className='yellow-icon-container'>
                      <BuildingColumns class_name="section-icon" />
                    </span>
                    <div>
                      <h3 className='color-white font-weight-200'>Automated Form 16 Generation</h3>
                      <h5 className='color-gray font-weight-200'>Generate Form 16 from TDS calculations</h5>
                    </div>
                  </div>
                  <span className='badge-green'><CircleCheck /> Active</span>
                </div>

                <Row>
                  <Col sm="6">
                    <h4 className='color-gray font-weight-200 font-14 mb-4'>Template Upload</h4>

                    <div
                      {...getRootProps()}
                      // style={{
                      //   background: isDragActive ? "#f0f8ff" : "#00000010",
                      // }}
                      className="dropzone mt-4 mb-4"
                    >
                      <input {...getInputProps()} />
                      {isDragActive ? (
                        <p>Drop the files here...</p>
                      ) : (
                        <div className="dropzone-inner-layout">
                          <span> <CloudUploadAlt /> </span>
                          <h3 className="mt-4 color-white font-weight-200">Drag & drop some files here</h3>
                          <h5 className="mb-3 color-gray font-weight-200 font-14">or click to browse</h5>
                          <h4 className="color-gray font-weight-200">Supports: PDF, DOC, EXCEL . Max size: 10MB</h4>
                          <h3 className='text-purple font-weight-200 font-14 mt-2'>Upload New Template</h3>
                        </div>
                      )}
                    </div>

                    <h4 className='color-gray font-weight-200 font-14 mb-4'>Verification Settings</h4>
                    ``
                    {/* ---------------------- */}
                    <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-1'>
                      <span className='color-white font-14 font-weight-200'>Auto-verify uploads</span>
                      <Switch checked />
                    </div>
                    {/* ---------------------- */}
                    <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                      <span className='color-white font-14 font-weight-200'>Generate verification report</span>
                      <Switch checked />
                    </div>
                    {/* ---------------------- */}

                    {/* ------------- */}
                    <div className='d-flex align-items-center gap-3 mb-2 mt-4'>
                      <button className='test-btn'> <Flask class_name={"text-purple"} /> Test Connection</button>
                      <button className='universal-btn border-radius-8px d-flex align-items-center justify-content-center gap-2 px-3' style={{ height: "40px" }}> <Upload /> Upload Return</button>
                      <button className='test-btn border-radius-8px d-flex align-items-center justify-content-center gap-2 px-3' style={{ height: "40px" }}> <Download /> Download Report</button>
                    </div>
                  </Col>
                  {/* ---------------------- */}
                  <Col sm="6">
                    <h4 className='color-gray font-weight-200 font-14 mb-4'>Recent Uploads</h4>
                    <div className='setting-border height-auto p-4'>
                      <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                        <span className='color-gray font-14 font-weight-200'>Q1_2024_TDS_Return.txt</span>
                        <span className='green-text'><Check class_name={"green-text"} /> Verified </span>
                      </div>
                      {/* ---------------------- */}
                      <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                        <span className='color-gray font-14 font-weight-200'>Q2_2024_TDS_Return.txt</span>
                        <span className='green-text'><Check class_name={"green-text"} /> Verified </span>
                      </div>
                      {/* ---------------------- */}
                      <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                        <span className='color-gray font-14 font-weight-200'>Q3_2024_TDS_Return.txt</span>
                        <span className='green-text'><Check class_name={"green-text"} /> Verified </span>
                      </div>
                      {/* ---------------------- */}
                    </div>
                    {/* ---------------------- */}
                    <h3 className='color-gray font-14 font-weight-200 mt-4 mb-4'>Verification Stats</h3>
                    <div className='setting-border height-auto p-4'>
                      <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                        <span className='color-gray font-14 font-weight-200'>Files processed:</span>
                        <span className='color-white'>24 </span>
                      </div>
                      {/* ---------------------- */}
                      <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                        <span className='color-gray font-14 font-weight-200'>Success rate:</span>
                        <span className='green-text'> 100% </span>
                      </div>
                      {/* ---------------------- */}
                      <div className='d-flex aliugn-items-center justify-content-between gap-2 mb-2'>
                        <span className='color-gray font-14 font-weight-200'>Last upload:</span>
                        <span className='green-text'> 3 days ago </span>
                      </div>
                      {/* ---------------------- */}
                    </div>

                  </Col>
                </Row>
              </div>
            </Col>

          </Row>
        </div>

      </section>

      {/* Section 4 ----------------------- */}
      <section className="setting-border height-auto mt-4 mb-4">
        <div className='setting-card-header'>
          <h3 className='color-white font-weight-200'> <ListUl class_name="section-icon text-purple" /> Integration Logs </h3>
          <div className='d-flex align-items-center gap-3'>
            <span className='d-flex align-items-center justify-content-center gap-2 text-purple'> <RefreshCw /> Refresh </span>
            <span className='d-flex align-items-center justify-content-center gap-2 text-purple'> <Download /> Download </span>
          </div>
        </div>

        <div className='p-4 mb-8'>
          <div className='setting-border height-auto p-3 d-flex align-items-center justify-content-between gap-2'>
            <div className='d-flex align-items-center gap-3'>
              <CircleCheck class_name={"green-text"} />
              <div>
                <h3 className='color-white font-12 font-weight-200'>SAP SuccessFactors sync completed</h3>
                <h5 className='color-gray font-12 font-weight-200'>3,456 employee records synchronized successfully</h5>
              </div>
            </div>
            <span className='color-gray font-12 font-weight-200'>
              30 min ago
            </span>
          </div>

           <div className='setting-border height-auto p-3 d-flex align-items-center justify-content-between gap-2 mt-2'>
            <div className='d-flex align-items-center gap-3'>
              <CircleCheck class_name={"green-text"} />
              <div>
                <h3 className='color-white font-12 font-weight-200'>SAP SuccessFactors sync completed</h3>
                <h5 className='color-gray font-12 font-weight-200'>3,456 employee records synchronized successfully</h5>
              </div>
            </div>
            <span className='color-gray font-12 font-weight-200'>
              2 hours ago
            </span>
          </div>

           <div className='setting-border height-auto p-3 d-flex align-items-center justify-content-between gap-2 mt-2'>
            <div className='d-flex align-items-center gap-3'>
              <CircleCheck class_name={"green-text"} />
              <div>
                <h3 className='color-white font-12 font-weight-200'>SAP SuccessFactors sync completed</h3>
                <h5 className='color-gray font-12 font-weight-200'>3,456 employee records synchronized successfully</h5>
              </div>
            </div>
            <span className='color-gray font-12 font-weight-200'>
              2 hours ago
            </span>
          </div>
        </div>
      </section>

    </div>
  )
}

export default Integrations